import fetch from 'unfetch';
import { csvParse } from 'd3-dsv';
import turfDistance from '@turf/distance';

function createLatLngLookup(data) {
  return data.reduce((res, item) => {
    res[item.Territorium] = res[item.Territorium] ? res[item.Territorium] : item.LatLng;
    return res;
  }, {});
}

export async function loadData() {
  try {
    const resp = await fetch('data/data-wolf-ani.csv');
    const text = await resp.text();
    const rawData = csvParse(text).map(d => {
      d.LatLng = d.LatLng.split(',').map(d => +d);
      d.year = +d['Monitoring-Jahr'].split('/')[0];
      d.key = `${d['Territorium-Kürzel']}_${d.year}`;

      return d;
    });

    const movements = parseMovements(rawData);
    const areas = parseAreas(rawData);

    return {
      areas,
      movements
    };
  } catch (e) {
    console.log(e);
  }
}

function parseMovements(rawData) {
  const latlngLookup = createLatLngLookup(rawData);

  return rawData
    .map(d => {
      d.w_origin = latlngLookup[d['Herkunft Fähe']];
      d.m_origin = latlngLookup[d['Herkunft Rüde']];
      d.steps = [[],[]];

      if (d.w_origin) {
        d.steps[0].push({ type: 'origin', center: d.w_origin });
        d.steps[1].push({ type: 'target', center: d.LatLng });
      }

      if (d.m_origin) {
        d.steps[0].push({ type: 'origin', center: d.m_origin });
        d.steps[1].push({ type: 'target', center: d.LatLng });
      }

      return d;
    });
}

function parseAreas(rawData) {
  return rawData.reduce((res, item) => {
    const matchingArea = res.find(d => d.area === item.Territorium);
    if (!matchingArea) {
      res.push({
        area: item.Territorium,
        data: [item]
      })
    } else {
      matchingArea.data.push(item);
    }

    return res;
  }, []);
}


export function getClosestArea(fromLatLng, areas) {
  const areas2018 = areas.reduce((res, area) => {
    const area2018 = area.data.find(d => d.year === 2017);
    if (typeof area2018 !== 'undefined') {
      res.push(area2018)
    }

    return res;
  }, []);

  const from = {
    type: 'Point',
    coordinates: [fromLatLng.longitude, fromLatLng.latitude]
  };

  return areas2018.reduce((res, area) => {
    const to = {
      type: 'Point',
      coordinates: [area.LatLng[1], area.LatLng[0]]
    };
    const distance = turfDistance(from, to);
    if (distance < res.minDistance) {
      res.minDistance = distance;
      res.area = area;
    }
    return res;
  }, { minDistance: Number.MAX_VALUE, area: null })

}